import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import React from 'react'

import { Translation } from 'cng-common/features/translations'
import { Switch } from 'core-components/library/checkbox'

import styles from './BusinessPerformanceSwitcher.module.scss'

interface IBusinessPerformanceSwitcherProps {
  isTurnOn?: number
  onChange: (flag: boolean) => void
}

export const BusinessPerformanceSwitcher = ({
  isTurnOn,
  onChange,
}: IBusinessPerformanceSwitcherProps) => {
  return (
    <div className={styles.switchBg}>
      <Switch size={'sm'} checked={Boolean(isTurnOn)} onChange={onChange} />
      <div className={styles.switchLabel}>
        <Translation text={getFormedEltTranslation('toggle-business-performance')} />
      </div>
    </div>
  )
}
